import React, { useState } from "react";
import herbalVideo from "../assets/Hurbal (1).mp4";

const points = [
  {
    title: "Sustainably Sourced",
    description:
      "We source premium Ayurvedic herbs from the Himalayas using environmentally responsible practices.", // Keyword added
    backContent:
      "हमारे जड़ी-बूटियाँ हिमालय की घाटियों से हाथ से चुनी जाती हैं, ताकि उनकी प्राचीन शुद्धता और अधिकतम प्रभावशीलता सुनिश्चित हो सके।",
  },
  {
    title: "Certified Organic",
    description:
      "100% Natural & Organic ingredients ensure high-quality Ayurvedic products without harmful chemicals.", // Keyword added
    backContent:
      "शुद्ध, प्रमाणित जैविक तत्वों से बने, हमारे उत्पाद किसी भी रासायनिक मिलावट के बिना आयुर्वेद के सच्चे सार को दर्शाते हैं।",
  },
  {
    title: "Fairly Traded",
    description:
      "Supporting local farmers with equitable supply chains ensuring the social and economic well-being.",
    backContent:
      "हम अपने किसानों के ज्ञान और परंपरा का सम्मान करते हैं, निष्पक्ष व्यापार सुनिश्चित करते हैं जो प्राचीन ज्ञान और स्थानीय समुदायों को जीवित रखता है।",
  },
];

const NewHeroSection = () => {
  const [flipped, setFlipped] = useState<number | null>(null);

  return (
    <div className="relative w-full bg-gray-100">
      {/* Main video background */}
      <div className="relative h-[500px] w-full overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
          // SEO: Descriptive title
          title="Ayurveda holistic wellness and natural healing journey"
        >
          <source src={herbalVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black opacity-30"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center items-start text-white">
          {/* Updated H1: Targeting Authentic Ayurveda & Wellness */}
          <h1 className="text-4xl text-white sm:text-5xl lg:text-6xl font-bold leading-tight mb-4">
            Experience Authentic Ayurveda: <br/>The Science of Life & Holistic Wellness
          </h1>
          <p className="text-lg text-gray-300 sm:text-xl font-medium max-w-xl">
            Discover a holistic approach to wellness with ancient wisdom, natural remedies, and modern convenience.
          </p>
        </div>
      </div>

      {/* Cards Section */}
      <div className="relative -mt-32 md:-mt-48 z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-8 md:py-16">
          {points.map((point, index) => (
            <div
              key={index}
              className="relative w-full h-64 perspective"
              onMouseEnter={() => setFlipped(index)}
              onMouseLeave={() => setFlipped(null)}
            >
              <div
                className={`relative w-full h-full transition-transform duration-700 transform-style-preserve-3d ${
                  flipped === index ? "rotate-y-180" : ""
                }`}
              >
                {/* Front Side - Ab isme gradient hai */}
                <div className="absolute inset-0 bg-gradient-to-t from-green-50 to-white rounded-lg shadow-lg flex flex-col items-center text-center p-6 backface-hidden">
                  <div className="h-16 w-16 text-4xl font-extrabold text-green-600 mb-4 flex items-center justify-center">
                    0{index + 1}
                  </div>
                  {/* H3 Tags are good for sub-topics */}
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    {point.title}
                  </h3>
                  <p className="text-gray-600">{point.description}</p>
                </div>

                {/* Back Side - Content with slide-up transparent gradient */}
                <div className="absolute inset-0 rounded-lg shadow-lg overflow-hidden backface-hidden rotate-y-180 bg-green-500">
                  <div
                    className={`absolute inset-x-0 bottom-0 w-full flex flex-col justify-end items-center text-center p-6 text-white
                    transition-all duration-500 ease-in-out
                    ${
                      flipped === index
                        ? "h-full bg-gradient-to-t from-green-700 via-green-600/80 to-transparent opacity-100"
                        : "h-0 bg-gradient-to-t from-green-700 via-green-600/80 to-transparent opacity-0"
                    }`}
                  >
                    <h3 className="text-2xl font-bold mb-2">
                      {point.title}
                    </h3>
                    <p className="text-lg">{point.backContent}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewHeroSection;